import React from 'react'

export function HelpTooltip(props) {
  return (
    <span
      aria-live="assertive"
      aria-describedby={props.ariaDescribedBy}
      className="helpful-tooltip"
    >
      {props.message}
    </span>
  )
}
